/* Cola Feliz · comportamiento del tema
   Todo arranca leyendo atributos data-* del HTML, sin dependencias. */
(() => {
  'use strict';
  console.log('[Cola Feliz] tema v3 cargado');
  const SIN_MOV = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];

  /* lee un <script type="application/json"> con red de seguridad */
  function datos(contenedor, marca, porDefecto) {
    try {
      const el = contenedor.querySelector(`script[${marca}]`);
      if (!el) return porDefecto;
      const v = JSON.parse(el.textContent.trim());
      return v == null ? porDefecto : v;
    } catch (e) {
      console.warn('[Cola Feliz] no pude leer', marca, e);
      return porDefecto;
    }
  }

  /* ───────── caja de cartón en 3D ───────── */

  /* reparto en cuadrícula: las piezas nunca se solapan */
  function reparto(n) {
    const escala = n <= 2 ? 1 : n <= 3 ? .9 : .8;
    const dx = 174 * escala, dy = 176 * escala;
    const filas = n <= 3 ? [n] : n === 4 ? [2, 2] : n === 5 ? [3, 2] : n === 6 ? [3, 3] : [3, 3, n - 6];
    const base = -168 - (filas.length - 1) * dy;
    const sitios = [];
    filas.forEach((cuantos, fila) => {
      for (let i = 0; i < cuantos; i++)
        sitios.push({ x: (i - (cuantos - 1) / 2) * dx, y: base + fila * dy, escala });
    });
    return sitios;
  }

  function abre(caja, si) {
    caja.classList.toggle('abierta', si);
    $$('.pieza', caja).forEach((p, i) => setTimeout(() => {
      if (si) { p.classList.remove('apagada'); p.style.transform = p.dataset.destino; }
      else    { p.classList.add('apagada');    p.style.transform = ''; }
    }, si ? 420 + i * 110 : i * 50));
  }

  function animaCaja(caja, { autogiro = true } = {}) {
    let gY = -26, gX = -18, arrastra = false, px = 0, py = 0, recorrido = 0, abierta = false;
    if (!SIN_MOV) {
      const bucle = () => {
        if (autogiro && !arrastra && !abierta) gY += .16;
        caja.style.transform = `rotateX(${gX}deg) rotateY(${gY}deg)`;
        const contra = `rotateY(${-gY}deg) rotateX(${-gX}deg)`;
        for (const f of caja.getElementsByClassName('frente-pieza')) f.style.transform = contra;
        if (caja.isConnected) requestAnimationFrame(bucle);
      };
      requestAnimationFrame(bucle);
    }
    caja.addEventListener('pointerdown', e => {
      arrastra = true; recorrido = 0; px = e.clientX; py = e.clientY;
      caja.setPointerCapture(e.pointerId);
    });
    caja.addEventListener('pointermove', e => {
      if (!arrastra) return;
      recorrido += Math.abs(e.clientX - px) + Math.abs(e.clientY - py);
      gY += (e.clientX - px) * .4;
      gX = Math.min(25, Math.max(-55, gX - (e.clientY - py) * .28));
      px = e.clientX; py = e.clientY;
    });
    for (const ev of ['pointerup', 'pointercancel']) caja.addEventListener(ev, () => {
      if (arrastra && recorrido < 8) caja.dispatchEvent(new CustomEvent('toque'));
      arrastra = false;
    });
    return {
      get abierta() { return abierta; },
      alterna() { abierta = !abierta; abre(caja, abierta); return abierta; },
      abrir() { if (!abierta) { abierta = true; abre(caja, true); } }
    };
  }

  /* La caja ya viene dibujada en el HTML (snippet cf-caja).
     Aquí solo se coloca cada pieza y se le da movimiento. */
  function colocaPiezas(caja) {
    const piezas = $$('.pieza', caja);
    if (!piezas.length) return;
    const sitios = reparto(piezas.length);
    piezas.forEach((el, i) => {
      const s = sitios[i];
      el.dataset.destino = `translate3d(${s.x | 0}px,${s.y | 0}px,0) scale(${s.escala})`;
    });
  }

  function montaCajas() {
    $$('[data-caja3d]').forEach(escena => {
      if (escena.dataset.montada) return;
      escena.dataset.montada = '1';
      const caja = $('.caja3d', escena);
      if (!caja) { console.warn('[Cola Feliz] la escena no trae caja'); return; }
      colocaPiezas(caja);
      const pista = $('.pista', escena);
      const api = animaCaja(caja, { autogiro: escena.dataset.autogiro !== 'no' });
      if (escena.dataset.abierta === 'si') setTimeout(() => api.abrir(), 350);
      caja.addEventListener('toque', () => {
        const ab = api.alterna();
        if (pista) pista.textContent = ab
          ? (escena.dataset.pistaAbierta || '🐾 Esto lleva dentro')
          : (escena.dataset.pistaCerrada || '👆 Toca la caja');
      });
    });
  }

  /* ───────── jauría en 3D (acceso y club) ───────── */
  function montaJauria() {
    const capa = $('[data-jauria]');
    if (!capa || capa.dataset.montada) return;
    capa.dataset.montada = '1';
    const fotos = datos(capa, 'data-cf-jauria', []);
    if (!fotos.length) return;

    const ANILLOS = [
      { n: 14, radio: 1.02, alto: -0.30, vel:  0.000052, base:  74, giro: 0 },
      { n: 12, radio: 0.78, alto:  0.06, vel: -0.000068, base:  96, giro: 1.1 },
      { n:  8, radio: 0.52, alto:  0.40, vel:  0.000088, base: 124, giro: 2.3 }
    ];
    const perros = [];
    let k = 0;
    for (const a of ANILLOS) {
      for (let i = 0; i < a.n; i++) {
        const el = document.createElement('div');
        el.className = 'can';
        el.innerHTML = `<img src="${fotos[k % fotos.length]}" alt="" loading="lazy">`;
        capa.appendChild(el);
        perros.push({
          el, ...a,
          fase: a.giro + i * (Math.PI * 2 / a.n),
          bamboleo: 0.5 + (i % 5) * 0.24,
          desfase: i * 1.7,
          tam: a.base * (0.86 + (i % 4) * 0.11)
        });
        k++;
      }
    }

    let W = capa.clientWidth, H = capa.clientHeight;
    const mide = () => { W = capa.clientWidth; H = capa.clientHeight; };
    if ('ResizeObserver' in window) new ResizeObserver(mide).observe(capa);
    addEventListener('resize', mide, { passive: true });

    const raton = { x: 0, y: 0, sx: 0, sy: 0 };
    (capa.parentElement || capa).addEventListener('pointermove', e => {
      const r = capa.getBoundingClientRect();
      raton.x = ((e.clientX - r.left) / r.width  - .5) * 2;
      raton.y = ((e.clientY - r.top)  / r.height - .5) * 2;
    }, { passive: true });

    const pinta = t => {
      raton.sx += (raton.x - raton.sx) * .06;
      raton.sy += (raton.y - raton.sy) * .06;
      const cx = W / 2, cy = H * 0.5;
      const RX = Math.max(W * 0.44, 300), RY = Math.min(H * 0.16, 110);
      for (const p of perros) {
        const a = t * p.vel + p.fase;
        const prof = Math.cos(a);
        const kk = (prof + 1) / 2;
        const tam = p.tam * (0.34 + kk * 1.06);
        const x = cx + Math.sin(a) * RX * p.radio + raton.sx * 34 * kk;
        const y = cy + H * p.alto + Math.cos(a) * RY
                + Math.sin(t * 0.00055 * p.bamboleo + p.desfase) * 14
                + raton.sy * 22 * kk;
        const s = p.el.style;
        s.width = tam.toFixed(1) + 'px';
        s.transform = `translate3d(${(x - tam / 2).toFixed(1)}px,${(y - tam / 2).toFixed(1)}px,0)`
                    + ` rotate(${(Math.sin(a * 1.4 + p.desfase) * 5).toFixed(2)}deg)`;
        s.opacity = (0.18 + kk * 0.82).toFixed(3);
        s.filter  = `blur(${((1 - kk) * 3.2).toFixed(2)}px) saturate(${(0.55 + kk * 0.5).toFixed(2)})`;
        s.zIndex  = String(100 + Math.round(prof * 60));
      }
    };
    mide();
    if (SIN_MOV) { pinta(0); return; }
    const bucle = ts => { if (!capa.isConnected) return; pinta(ts); requestAnimationFrame(bucle); };
    requestAnimationFrame(bucle);
  }

  /* ───────── fondo que cambia al bajar ───────── */
  function montaFondo() {
    const capas = $$('#cf-capas .capa-tema');
    const chip = $('#cf-tema-chip');
    const rastros = [$('#cf-rastro-izq'), $('#cf-rastro-der')].filter(Boolean);
    if (!capas.length) return;
    const TEMAS = ['🐾 Cachorro en casa', '🌳 Paseo por el parque', '🌊 Día de playa',
                   '🎉 Hora de la fiesta', '🛋️ Siesta en el sofá'];
    const HUELLA = '<svg viewBox="0 0 100 100"><ellipse cx="26" cy="30" rx="11" ry="15"/><ellipse cx="46" cy="20" rx="11" ry="16"/><ellipse cx="68" cy="26" rx="11" ry="15"/><ellipse cx="82" cy="46" rx="10" ry="13"/><path d="M50 44c16 0 27 13 27 25s-12 15-27 15-27-3-27-15 11-25 27-25z"/></svg>';
    rastros.forEach(r => r.innerHTML = HUELLA.repeat(12));
    const pisadas = rastros.map(r => [...r.children]);
    let ultimo = -1, pendiente = false, previo = 0, sube = false;

    const pinta = () => {
      pendiente = false;
      const alto = document.documentElement.scrollHeight - innerHeight;
      const largo = alto > 1200;
      document.body.classList.toggle('pagina-corta', !largo);
      if (!largo) {
        capas.forEach((c, i) => c.style.opacity = i === 0 ? '1' : '0');
        if (chip) chip.textContent = TEMAS[0];
        ultimo = 0;
        return;
      }
      const p = Math.min(1, Math.max(0, scrollY / alto));
      if (Math.abs(scrollY - previo) > 4) { sube = scrollY < previo; previo = scrollY; }
      const pos = p * (capas.length - 1);
      capas.forEach((c, i) => c.style.opacity = Math.max(0, 1 - Math.abs(i - pos)).toFixed(3));
      const idx = Math.round(pos);
      if (idx !== ultimo && chip) {
        ultimo = idx; chip.textContent = TEMAS[idx];
        chip.style.scale = '1.12'; setTimeout(() => chip.style.scale = '', 220);
      }
      rastros.forEach(r => r.classList.toggle('sube', sube));
      pisadas.forEach(lista => lista.forEach((h, i) => h.classList.toggle('on', p * lista.length >= i)));
    };
    addEventListener('scroll', () => { if (!pendiente) { pendiente = true; requestAnimationFrame(pinta); } }, { passive: true });
    addEventListener('resize', pinta, { passive: true });
    pinta();
  }

  /* ───────── aparición al hacer scroll ───────── */
  function montaRevelado() {
    const items = $$('.cf .revela:not(.visible)');
    if (!items.length) return;
    if (SIN_MOV || !('IntersectionObserver' in window)) {
      items.forEach(i => i.classList.add('visible'));
      return;
    }
    const obs = new IntersectionObserver(es => es.forEach((e, i) => {
      if (!e.isIntersecting) return;
      setTimeout(() => e.target.classList.add('visible'), i * 80);
      obs.unobserve(e.target);
    }), { threshold: .14 });
    items.forEach(i => obs.observe(i));
  }

  /* ───────── inclinación 3D de las tarjetas ───────── */
  function montaInclinacion() {
    if (SIN_MOV || matchMedia('(pointer: coarse)').matches) return;
    $$('.cf .tarjeta:not([data-inclina])').forEach(t => {
      t.dataset.inclina = '1';
      let r = null;
      t.addEventListener('mouseenter', () => r = t.getBoundingClientRect());
      t.addEventListener('mousemove', e => {
        if (!r) return;
        const x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
        t.style.transform = `perspective(950px) rotateY(${x * 11}deg) rotateX(${-y * 11}deg) translateY(-8px)`;
      });
      t.addEventListener('mouseleave', () => { r = null; t.style.transform = ''; });
    });
  }

  /* ───────── buscador «dime para qué es» ───────── */
  function montaBuscador() {
    $$('[data-buscador]:not([data-montado])').forEach(caja => {
      caja.dataset.montado = '1';
      const fichas = datos(caja, 'data-cf-fichas', []);
      const hueco = $('.sugerencia', caja);
      const pinta = id => {
        const c = fichas.find(f => f.id === id) || fichas[0];
        if (!c || !hueco) return;
        hueco.innerHTML =
          `<div class="puck" style="background:${c.tono}">${c.icono}</div>
           <div><h4>${c.nombre}</h4><p>${c.resumen}</p></div>
           <div class="lado"><span class="tarifa">${c.precio}</span>
             <a class="btn btn--coral" href="${c.url}">Ver la caja</a></div>`;
      };
      caja.addEventListener('click', e => {
        const b = e.target.closest('[data-motivo]');
        if (!b) return;
        $$('[data-motivo]', caja).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        pinta(b.dataset.motivo);
      });
      if (fichas.length) pinta(fichas[0].id);
    });
  }

  function arranca() {
    montaFondo();
    montaCajas();
    montaJauria();
    montaBuscador();
    montaRevelado();
    montaInclinacion();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arranca);
  else arranca();
  document.addEventListener('shopify:section:load', arranca);
})();


/* ─────────────────────────────────────────────────────────────────────
   La página respira al bajar.

   Dos cosas se mueven con el scroll: el fondo de huellas se queda un
   poco atrás (da profundidad, como si hubiera dos planos) y la caja de
   la portada gira despacio sobre su eje mientras lees.

   Va todo por variables CSS, así que si el navegador o el sistema piden
   menos movimiento no se engancha ni un listener.
   ───────────────────────────────────────────────────────────────────── */
(() => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const fondo = document.querySelector('.fondo');
  const escena = document.querySelector('.cf .hero .escena');
  const vesc = document.querySelector('.cf .escenario-video video');
  if (!fondo && !escena && !vesc) return;

  const tope = (v, max) => Math.max(-max, Math.min(max, v));
  let pendiente = false;

  const pinta = () => {
    const y = window.scrollY;
    if (fondo) fondo.style.setProperty('--par', tope(y * 0.055, 80).toFixed(1) + 'px');
    if (escena) escena.style.setProperty('--giro', tope(y * 0.028, 7).toFixed(2) + 'deg');
    if (vesc) {
      const r = vesc.getBoundingClientRect();
      const centro = (r.top + r.height / 2 - innerHeight / 2) / innerHeight;
      vesc.style.setProperty('--pare', tope(centro * -46, 46).toFixed(1) + 'px');
    }
    pendiente = false;
  };

  window.addEventListener('scroll', () => {
    if (pendiente) return;
    pendiente = true;
    requestAnimationFrame(pinta);
  }, { passive: true });

  pinta();
})();

/* Si el sistema pide menos movimiento, el vídeo de portada no se lanza
   solo: se queda en su primer fotograma con sus mandos. */
(() => {
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  document.querySelectorAll('video.hero-video').forEach(v => {
    v.autoplay = false; v.loop = false; v.controls = true;
    v.pause();
  });
})();


/* ─────────────────────────────────────────────────────────────────────
   El guion de la mascota.

   Entra andando por la izquierda alternando dos posturas —eso es lo que
   hace que ande y no que resbale—, llega hasta la caja 3D y la toca con
   el morro. La caja se abre de verdad: se dispara el mismo evento que
   si la tocaras tú. Se sienta a mirarla, y luego sigue hasta la esquina
   derecha, donde se tumba y mueve la cola.

   Lo importante está en medirlo, no en escribirlo a ojo: las tres
   posiciones y la altura del suelo salen de la caja REAL, así que el
   perro pisa el mismo suelo que ella y le llega al morro caiga donde
   caiga la caja. Con porcentajes fijos acababa encima de los botones.

   Arranca cuando la portada entra en pantalla, no al cargar. Con
   «reducir movimiento» aparece ya tumbado en la esquina.
   ───────────────────────────────────────────────────────────────────── */
(() => {
  const guia = document.querySelector('[data-guia]');
  if (!guia) return;
  const portada = guia.closest('.hero');
  if (!portada) return;

  const poses = {};
  guia.querySelectorAll('.cf-pose').forEach(i => { poses[i.dataset.pose] = i; });
  const pon = (p) => {
    if (!poses[p]) return;
    for (const k in poses) poses[k].classList.toggle('on', k === p);
  };

  /* El morro del perro no llega al borde de la imagen: en los recortes
     está sobre el 96% del ancho. Sin esto, «tocar la caja» dejaría un
     hueco del tamaño del margen transparente. */
  const MORRO = 0.96;

  const sitios = { entra: 0, caja: 0, esquina: 0, suelo: 2 };

  function mide() {
    const hr = portada.getBoundingClientRect();
    const caja = portada.querySelector('.caja3d');
    const gw = guia.offsetWidth || 200;

    if (caja) {
      const cr = caja.getBoundingClientRect();
      const cajaX = cr.left - hr.left;
      const cajaAbajo = cr.bottom - hr.top;
      /* el morro se mete 18px en la caja: así se ve que la toca */
      sitios.caja = Math.round(cajaX + 18 - MORRO * gw);
      /* y pisa el mismo suelo que la caja, no el fondo de la portada */
      sitios.suelo = Math.max(0, Math.round(hr.height - cajaAbajo));
    } else {
      sitios.caja = Math.round(hr.width * 0.5);
      sitios.suelo = 2;
    }
    sitios.entra = -Math.round(gw * 1.2);
    sitios.esquina = Math.round(hr.width - gw);
    guia.style.setProperty('--guia-suelo', sitios.suelo + 'px');
  }

  const ve = (donde, segundos) => {
    guia.style.setProperty('--guia-paso', segundos + 's');
    guia.style.setProperty('--guia-x', sitios[donde] + 'px');
  };

  mide();
  guia.style.setProperty('--guia-x', sitios.entra + 'px');

  let acabado = false;
  addEventListener('resize', () => {
    const suelo = sitios.suelo;
    mide();
    if (acabado) {
      guia.style.setProperty('--guia-paso', '0s');
      guia.style.setProperty('--guia-x', sitios.esquina + 'px');
    } else if (suelo !== sitios.suelo) {
      /* nada más: la transición en curso se recalcula sola */
    }
  }, { passive: true });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    guia.style.transition = 'none';
    guia.style.setProperty('--guia-x', sitios.esquina + 'px');
    pon(poses.tumbado ? 'tumbado' : 'quieto');
    acabado = true;
    return;
  }

  const luego = (ms, fn) => setTimeout(fn, ms);
  let paso = null;
  const andando = (si) => {
    clearInterval(paso);
    if (!si) { pon('quieto'); return; }
    let alterna = false;
    paso = setInterval(() => { alterna = !alterna; pon(alterna ? 'anda' : 'quieto'); }, 150);
  };

  const arranca = () => {
    mide();
    andando(true);
    requestAnimationFrame(() => ve('caja', 2.4));

    luego(2400, () => { andando(false); guia.classList.add('empuja'); });

    luego(2820, () => {
      const caja = portada.querySelector('.caja3d');
      if (caja) caja.dispatchEvent(new CustomEvent('toque'));
    });

    luego(3150, () => { guia.classList.remove('empuja'); pon('sienta'); });

    /* se lo mira un momento y se va a su esquina */
    luego(4600, () => { andando(true); ve('esquina', 1.3); });

    luego(5900, () => {
      andando(false);
      pon('tumbado');
      guia.classList.add('cola');
      acabado = true;
    });
  };

  const ojo = new IntersectionObserver((entradas) => {
    if (!entradas.some(e => e.isIntersecting)) return;
    ojo.disconnect();
    luego(450, arranca);
  }, { threshold: 0.2 });
  ojo.observe(portada);
})();
